/**
 * LaunchDarkly Utility Functions
 *
 * Shared utilities for LaunchDarkly context creation and configuration
 */

/**
 * Creates a LaunchDarkly context object from domain data
 *
 * @param {Object} domain - Domain data from privacy policy API
 * @param {number} domain.domainId - Unique domain identifier
 * @param {string} domain.domainName - Domain name
 * @param {string} domain.domainEmail - Domain email
 * @param {string} domain.edition - Domain edition (enterprise, etc.)
 * @param {string} domain.subscriptiontype - Subscription type
 * @param {string} domain.subscriptionstatus - Subscription status
 * @param {string} domain.partnername - Partner name
 * @param {string} domain.IsTrial - Trial status ("0" or "1")
 * @param {Object} domain.sessionConfigurations - Session configuration
 * @param {string} domain.sessionConfigurations.DOMAINRELEASEVERSION - Release version
 * @returns {Object} LaunchDarkly context object
 */
export const createLDContext = (domain) => {
    if (!domain?.domainId) {
        return null;
    }

    return {
        kind: "user",
        key: domain.domainId.toString(),
        name: domain.domainName,
        email: domain.domainEmail,
        anonymous: false,
        custom: {
            ReleaseVersion: domain.sessionConfigurations?.DOMAINRELEASEVERSION || null,
            Edition: domain.edition || null,
            SubscriptionType: domain.subscriptiontype || null,
            DomainStatus: "ACTIVE",
            IsTrial: domain.IsTrial ? Boolean(Number(domain.IsTrial)) : null,
            SubscriptionStatus: domain.subscriptionstatus || null,
            PartnerName: domain.partnername || null,
        },
    };
};
